module.exports = __webpack_public_path__ + "static/media/userAvatarWhite.3b9ccf77.svg";